import { List } from 'immutable'
import setFilters from 'store/reducer-utils/setFilters'
import { updateObject } from 'utils/updateObject'

const initialState = {
  loading: true,
  data: [],
  pagination: {
    offset: 0,
    limit: 50,
    total: 0,
  },
  filters: null,
}

const setUserPaymentProfilePayments = (state, { payload }) => {
  return updateObject(state, {
    ...payload,
    data: List(state.data).concat(List(payload.data)).toJS(),
    loading: false,
  })
}

const setProfilePaymentsFilter = (state, action) => {
  const filteredPayload = state?.filters
    ? [...action.payload].filter(
        (filter) => Object.keys(state.filters).indexOf(filter.fieldName) > -1,
      )
    : action.payload

  return setFilters(state, { ...action, payload: filteredPayload })
}

const setLoading = (state, { payload }) => {
  return updateObject(state, payload)
}

const dropUserPaymentProfilePayments = (state) => {
  return updateObject(state, {
    data: [],
    pagination: {
      offset: 0,
      limit: 50,
      total: 0,
    },
  })
}

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case 'USER/SET_USER_PAYMENT_PROFILE_PAYMENTS':
      return setUserPaymentProfilePayments(state, action)
    case 'USER/PAYMENT_PROFILE_PAYMENTS_SET_FILTER':
      return setProfilePaymentsFilter(state, action)
    case 'USER/USER_PAYMENT_PROFILES_PAYMENTS_SET_LOADING':
      return setLoading(state, action)
    case 'USER/DROP_USER_PAYMENT_PROFILE_PAYMENTS':
      return dropUserPaymentProfilePayments(state)
    default:
      return state
  }
}

export default reducer
